/**
 * Order-status metadata: colour token + i18n key.
 * ALL_STATUSES is the strict lifecycle order used by StatusTimeline.
 * A18.3 — `draft` is intentionally excluded; drafts aren't part of an
 * order's public status timeline and don't render as a stage.
 */
export const ALL_STATUSES = [
  "order_placed",
  "confirmed",
  "in_progress",
  "shipped",
  "delivered",
  "collected",
  "quality_testing",
  "collection_complete",
];

/**
 * tone → visual family (neutral | info | success | warning | danger)
 * Each StatusBadge maps `tone` to a MH design-token colour set.
 */
export const STATUS_META = {
  draft: { tone: "neutral", i18n: "orders.status.draft" },
  order_placed: { tone: "info", i18n: "orders.status.order_placed" },
  confirmed: { tone: "success", i18n: "orders.status.confirmed" },
  in_progress: { tone: "info-alt", i18n: "orders.status.in_progress" },
  shipped: { tone: "info", i18n: "orders.status.shipped" },
  delivered: { tone: "success", i18n: "orders.status.delivered" },
  collected: { tone: "warning", i18n: "orders.status.collected" },
  quality_testing: { tone: "warning", i18n: "orders.status.quality_testing" },
  collection_complete: {
    tone: "success",
    i18n: "orders.status.collection_complete",
  },
  cancelled: { tone: "danger", i18n: "orders.status.cancelled" },
  rejected: { tone: "danger", i18n: "orders.status.rejected" },
};

export const CANCELLABLE_STATUSES = new Set([
  "order_placed",
  "confirmed",
  "in_progress",
]);

export const TERMINAL_STATUSES = new Set([
  "collection_complete",
  "cancelled",
  "rejected",
]);

export function isOpen(status) {
  return !TERMINAL_STATUSES.has(status);
}
